import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { NumpadModule } from '../../../lib/numpad/numpad.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import LinearContainerStakeComponent from './components/digital/linear/linear-container-stake.component';
import { LinearStakeKeyboardComponent } from './components/digital/linear/linear-stake-keyboard.component';
import { LinearStakeScrollDirective } from './components/digital/linear/linear-stake-scroll.directive';
import SingleBetPickStakeKeyboardComponent from './components/digital/single-bet-pick-stake-keyboard.component';
import SingleBetPickStakeComponent from './components/digital/single-bet-pick-stake.component';
import SummaryStakeKeyboardComponent from './components/digital/summary-stake-keyboard.component';
import SummaryStakeComponent from './components/digital/summary-stake.component';
import { LinearDefaultStakeEffects } from './linear-default-stake.effects';
import { MinStakeEffects } from './min-stake.effects';
import BetslipStakeConfigurationService from './services/betslip-stake-configuration.service';
import { BetslipStakeValidationService } from './services/digital/betslip-stake-validation.service';
import StakeConvertService from './services/stake-convert.service';
import { StakeEffects } from './stake.effects';

@NgModule({
    imports: [
        CommonModule,
        NumpadModule,
        DigitalRewardTokensModule,
        EffectsModule.forFeature([StakeEffects, LinearDefaultStakeEffects, MinStakeEffects]),
    ],
    declarations: [
        SingleBetPickStakeComponent,
        SingleBetPickStakeKeyboardComponent,
        SummaryStakeComponent,
        SummaryStakeKeyboardComponent,
        LinearContainerStakeComponent,
        LinearStakeKeyboardComponent,
        LinearStakeScrollDirective,
    ],
    exports: [
        SingleBetPickStakeComponent,
        SingleBetPickStakeKeyboardComponent,
        SummaryStakeComponent,
        SummaryStakeKeyboardComponent,
        LinearContainerStakeComponent,
        LinearStakeKeyboardComponent,
        LinearStakeScrollDirective,
    ],
    providers: [BetslipStakeConfigurationService, StakeConvertService, BetslipStakeValidationService],
})
export default class BetslipDigitalStakeModule {}
